import React from "react"

import type { InputProps } from "@chakra-ui/react"
import { Input } from "@chakra-ui/react"

import type { EditorProps } from "./Editor"

export const TextEditor = ({
  value,
  isValueInvalid,
  onValueChange,
  inputProps,
}: EditorProps<string> & { inputProps: InputProps }) => {
  return (
    <Input
      variant="flushed"
      value={value}
      isInvalid={isValueInvalid}
      onChange={(event) => {
        if (onValueChange) {
          onValueChange(event.currentTarget.value)
        }
      }}
      {...inputProps}
    />
  )
}
